import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/** Another dead spin: three L2 touch down the left edge, one short of a cluster, and the spin ends at once. */
export function noWin2(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-no-win-2", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L2", "H4", "L4", "H1", "H2", "L2"],
        ["L2", "L1", "H2", "L3", "L1", "L2"],
        ["L2", "L1", "L2", "H4", "H2", "H4"],
        ["L4", "L2", "L4", "L2", "H4", "H1"],
        ["L3", "L4", "H1", "H3", "L4", "L4"],
        ["H2", "L4", "L3", "L1", "L1", "L2"],
      ],
      refill: [[], [], [], [], [], []],
    })
    .build();
}
